// ═══════════════════════════════════════════════════════════════════════════
// Solicitudes de precio especial — la capa de datos
//
// El vendedor pide, el dueño o un gerente autoriza, y autorizar APLICA el
// precio. Todo pasa por funciones de Postgres (migración 0026): quién puede
// pedir por qué cliente, quién puede decidir y que nadie decida lo suyo se
// comprueba allá.
//
// Aquí NO se repite ninguna de esas comprobaciones, a propósito — es la misma
// regla que en `vendedores.js`: duplicarlas en el navegador daría la falsa
// impresión de que sirven de algo.
//
// Tampoco va por la bitácora offline. Pedir un precio y autorizarlo son actos
// que necesitan respuesta: una solicitud que se sube "en algún momento" deja al
// vendedor sin saber si puede vender a ese precio, que es justo lo que venía a
// resolver.
// ═══════════════════════════════════════════════════════════════════════════

import { supabase } from "../auth/sesion.js";

async function rpc(nombre, args) {
  const { data, error } = await supabase.rpc(nombre, args);
  if (error) throw new Error(error.message);
  return data;
}

/** Los dos tipos, con las palabras que se usan en la pantalla. */
export const TIPO_SOLICITUD = {
  precio_producto:   { clave: "precio_producto",   etiqueta: "Precio de un producto", unidad: "$" },
  descuento_cliente: { clave: "descuento_cliente", etiqueta: "Descuento del cliente", unidad: "%" },
};

export const ESTADO_SOLICITUD = {
  pendiente:  { clave: "pendiente",  etiqueta: "Pendiente",  color: "#facc15" },
  autorizada: { clave: "autorizada", etiqueta: "Autorizada", color: "#a8d060" },
  rechazada:  { clave: "rechazada",  etiqueta: "Rechazada",  color: "#c97070" },
};

/**
 * Pedir un precio especial.
 * @param tipo    "precio_producto" | "descuento_cliente"
 * @param valor   pesos si es de producto, porcentaje si es el descuento
 */
export const solicitarPrecio = (tenantId, clientId, tipo, productId, valor, motivo) =>
  rpc("solicitar_precio", {
    p_tenant: tenantId, p_client: clientId, p_tipo: tipo,
    p_product: tipo === "precio_producto" ? productId : null,
    p_valor: valor, p_motivo: motivo || null,
  });

/** Autorizar (aplica el precio) o rechazar. */
export const resolverPrecio = (solicitudId, autorizar, nota) =>
  rpc("resolver_precio", {
    p_solicitud: solicitudId, p_autorizar: !!autorizar, p_nota: nota || null,
  });

/**
 * La cola. La RLS decide qué se ve: gerencia, todo lo de su vinícola; el
 * vendedor, solo lo que él pidió. No hace falta filtrar por rol aquí.
 *
 * @param estado  filtra por estado; sin él, todo (para ver el historial)
 */
export async function solicitudes(tenantId, estado = null) {
  let q = supabase.from("price_request_detalle").select("*")
    .eq("tenant_id", tenantId).order("created_at", { ascending: false });
  if (estado) q = q.eq("estado", estado);
  const { data, error } = await q;
  if (error) throw new Error(error.message);
  return data || [];
}

/** Cuántas esperan respuesta. Para el aviso de quien autoriza. */
export async function pendientes(tenantId) {
  const { count, error } = await supabase.from("price_request")
    .select("id", { count: "exact", head: true })
    .eq("tenant_id", tenantId).eq("estado", "pendiente");
  if (error) throw new Error(error.message);
  return count || 0;
}
